import { useState } from "react";

import { Core } from "..";
import * as S from "./styles";

export const DigitSeparated = ({ digits, gridArea, margin, ...rest }) => {
  const [value, setValue] = useState(Array(digits).fill(0));

  const handleChange = (e) => {
    setValue((prev) => {
      const { name, value } = e.target;
      const newValue = [...prev];
      newValue[name] = value ? parseInt(value) : 0;
      const nextInput = document.querySelector(
        `input[name="${parseInt(name) + 1}"]`,
      );
      if (nextInput && value !== "") {
        nextInput.focus();
      }
      return newValue.join("");
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && e.target.value === "") {
      const previousInput = document.querySelector(
        `input[name="${parseInt(e.target.name) - 1}"]`,
      );
      if (previousInput) {
        previousInput.focus();
      }
    }
  };

  return (
    <>
      <S.InputWrapper digits={digits} gridArea={gridArea} margin={margin}>
        {Array(digits)
          .fill(0)
          .map((_, index) => {
            return (
              <S.Input
                pattern="[0-9]"
                required
                placeholder="0"
                {...rest}
                type="text"
                maxLength={1}
                key={index}
                name={index}
                onChange={(e) => {
                  handleChange(e);
                  rest?.onChange && rest.onChange(e);
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                  rest?.onKeyDown && rest.onKeyDown(encodeURI);
                }}
              />
            );
          })}
      </S.InputWrapper>
      <S.Wrapper>
        <Core {...rest} value={value} />
      </S.Wrapper>
    </>
  );
};
